module.exports = __webpack_public_path__ + "media/images/front/icon_blank_01-2611d562d4852a95d2684ecfee8e5204.svg";